import actions from './actions';

const initialState = {
  data: [],
  url: null,
  fileLoading: false, 
  loading: false,
  error: null,
};

const initialStateSingle = {
  data: null,
  loading: false,
  error: null,
};

const volunteerApplicationFormsReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {

    case actions.VOLUNTEER_APPLICATION_FORM_ADD_BEGIN:
      return {
        ...state,
        loading: true,
      };

    case actions.VOLUNTEER_APPLICATION_FORM_ADD_SUCCESS:
      return {
        ...state,
        data,
        error: false,
        loading: false,
      };

    case actions.VOLUNTEER_APPLICATION_FORM_ADD_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case actions.VOLUNTEER_APPLICATION_FORMS_READ_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.VOLUNTEER_APPLICATION_FORMS_READ_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.VOLUNTEER_APPLICATION_FORMS_READ_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };

    case actions.VOLUNTEER_APPLICATION_FORM_UPDATE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case actions.VOLUNTEER_APPLICATION_FORM_UPDATE_SUCCESS:
      return {
        ...state,
        data, 
        error: false,
        loading: false,
      };
    case actions.VOLUNTEER_APPLICATION_FORM_UPDATE_ERR:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

const volunteerApplicationFormReducer = (state = initialStateSingle, action) => {
  const { type, data, err } = action;
  switch (type) {
    case actions.VOLUNTEER_APPLICATION_FORM_READ_BEGIN:
      return {
        ...initialStateSingle,
        loading: true,
      };

    case actions.VOLUNTEER_APPLICATION_FORM_READ_SUCCESS:
      return {
        ...initialStateSingle,
        data,
        error: false,
        loading: false,
      };

    case actions.VOLUNTEER_APPLICATION_FORM_READ_ERR:
      return {
        ...initialStateSingle,
        error: err,
        loading: false,
      };

    default:
      return state;
  }
};

export { 
  volunteerApplicationFormsReducer, 
  volunteerApplicationFormReducer,
};
